<template>
  <dialog-view
      :open="open"
      title="Настройки"
      big
      contentFullSize
      @cancel="close()"
  >
    <template v-slot:content>
      <v-tabs v-model="tab" background-color="transparent">
        <v-tab>Триггерные сообщения</v-tab>
      </v-tabs>
      <v-divider/>
      <div v-if="tab===0">
        <distribute-page-message-trigger :height="contentHeight"/>
      </div>
    </template>
  </dialog-view>
</template>

<script>
import DialogView from "@/components/DialogView.vue";
import DistributePageMessageTrigger from "./DistributePageMessageTrigger.vue";

export default {
  components: {DialogView, DistributePageMessageTrigger},
  props: ['open', 'height'],
  data: () => ({
    tab: 0,
  }),
  computed: {
    contentHeight() {
      return Math.max(400, (this.height || 600) - 48 - 48);
    },
  },
  methods: {
    close() {
      this.$emit('cancel');
    },
  },
}
</script>
